import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import download from '../../../../assets/download.svg';
import { Instances } from '../../../../constants';
import { setDownloadStatus } from '../../../../store/actions/download.action';
import { IStateType } from '../../../../store/models/root.interface';
import Spinner from '../../atoms/Spinner';
import downloadService from './download.service';
import Styles from './index.module.scss';

type DownloadPropTypes = {
	instanceId: Instances;
	message: string;
	params?: Record<string, any>;
	requestParams?: Record<string, any>;
};

const DownloadButton: React.FC<DownloadPropTypes> = ({
	instanceId,
	message,
	params,
	requestParams,
}) => {
	const dispatch = useDispatch();
	const downloadSelector = useSelector((state: IStateType) => state.download);

	return (
		<>
			{
				downloadSelector.downloadStatus ?
					<button
						onClick={() => {
							dispatch(setDownloadStatus(false));
							downloadService(instanceId, message, params, requestParams)
						}
						}
						className={Styles.downloadButtonStyle}
					>
						<img src={download} alt="download"/>
					</button> : <Spinner />
			}
		</>

	)
}

export default DownloadButton;
